import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PasswordConfirmationValidatorService } from '@services/custom-validators/password-confirm-validator.service';
import { CustomersService } from '@services/entity/customers.service';
import { UsersService } from '@services/entity/users.service';
import { FormService } from '@services/form/form.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { UserProfile } from '@dto/userProfile';
import { PricingsService } from '@services/entity/pricings.service';
import { User } from '@models/identity/user';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { ResetPasswordRequest } from '@dto/resetPasswordRequest';
import { DatasecurityComponent } from '../datasecurity/datasecurity.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SubscriptionDetailDto } from '@dto/subscriptionDetailDto';
import { UpdateAcceptAdRequestDto } from '../../../dto/updateAcceptAdRequestDto';

@Component({
  selector: "app-welcome-user",
  templateUrl: "./welcome-user.component.html",
  styleUrls: ["./welcome-user.component.scss"],
})
export class WelcomeUserComponent implements OnInit {
  public page: number;
  @ViewChild("customerView") customerView: TemplateRef<any>;

  private pwResetToken: string;

  public user: User;
  public userProfile: UserProfile;
  public permissions = {} as any;

  public passwordHasUpperCase: boolean = false;
  public passwordHasLowerCase: boolean = false;
  public passwordHasDigit: boolean = false;
  public passwordHasLength: boolean = false;
  public passwordHasSpecialCharacter: boolean = false;
  public passwordQuality: number = 0;
  public passwordIsMatching: boolean = false;
  public passwordRating: string = "";
  public passwordRatings: Array<string> = [
    "",
    "Sehr Schwach",
    "Schwach",
    "Ausreichend",
    "Gut",
    "Stark",
    "Sehr Stark",
    "Super Stark",
    "Stark wie Krupp Stahl",
  ];
  public subscriptionDetails: SubscriptionDetailDto;
  public loadingSubscriptionDetails: boolean;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public authenticationService: AuthenticationService,
    public customersService: CustomersService,
    public usersService: UsersService,
    public formService: FormService,
    public pricingsService: PricingsService,
    private passwordConfirmValidator: PasswordConfirmationValidatorService,
    public dialog: NgbModal
  ) {}

  //Test#123456

  ngOnInit(): void {
    this.loadingSubscriptionDetails = true;
    this.page = 1;
    this.getUser();
    this.createForm();
  }

  createForm() {
    this.formService.validators = {
      newPassword: [
        Validators.required,
        Validators.pattern(/(?=.*[A-Z])(?=.*[a-z])(?=.*\d)/g),
        Validators.minLength(10),
      ],
      newPasswordConfirm: [
        Validators.required,
        Validators.pattern(/(?=.*[A-Z])(?=.*[a-z])(?=.*\d)/g),
        Validators.minLength(10),
      ],
      agbConfirm: [Validators.requiredTrue],
      wrbConfirm: [Validators.requiredTrue],
      dsbConfirm: [Validators.requiredTrue],
    };

    this.formService.form = new UntypedFormGroup({
      newPassword: new UntypedFormControl(
        "",
        this.formService.validators["newPassword"]
      ),
      newPasswordConfirm: new UntypedFormControl(
        "",
        this.formService.validators["newPasswordConfirm"]
      ),
      agbConfirm: new UntypedFormControl(
        "",
        this.formService.validators["agbConfirm"]
      ),
      wrbConfirm: new UntypedFormControl(
        "",
        this.formService.validators["wrbConfirm"]
      ),
      dsbConfirm: new UntypedFormControl(
        "",
        this.formService.validators["dsbConfirm"]
      ),
      infoConfirm: new UntypedFormControl(""),
    });

    this.formService.form
      .get("newPasswordConfirm")
      .setValidators([
        Validators.required,
        this.passwordConfirmValidator.validateConfirmPassword(
          this.formService.form.get("newPassword")
        ),
      ]);
  }

  getUser() {
    var userEmail = this.activatedRoute.snapshot.queryParams.email;
    this.pwResetToken = this.activatedRoute.snapshot.queryParams.token;
    this.usersService.getUserByEmail(userEmail).subscribe((user) => {
      this.user = user;
      this.usersService.getUserProfileById(user.id).subscribe((userProfile) => {
        this.userProfile = userProfile;
      });
      // this.customersService.getCustomerPermissions(user.selectedCustomerId).subscribe(permissions => {
      //   permissions.forEach(permissionObject => {
      //     this.permissions[permissionObject.permission.name] = permissionObject.value;
      //   })
      // });
      this.customersService
        .getSubscriptionDetailsOfCustomer(user.selectedCustomerId)
        .subscribe((subscriptionDetails) => {
          this.subscriptionDetails = subscriptionDetails;
          this.loadingSubscriptionDetails = false;
        });
    });
  }

  onSubmit(formValue) {
    const resetPasswordRequest: ResetPasswordRequest = {
      password: formValue.newPassword,
      confirmPassword: formValue.newPasswordConfirm,
      token: this.pwResetToken,
      email: this.user.email,
    };

    this.authenticationService.resetPassword(resetPasswordRequest).subscribe(
      (result) => {
        this.authenticationService
          .confirmEmailFromOnboarding(this.user.id)
          .subscribe(
            (result) => {
              this.usersService
                .updateAcceptAd({
                  UserId: this.user.id,
                  AcceptAd: this.formService.form.get("infoConfirm")?.value,
                } as UpdateAcceptAdRequestDto)
                .subscribe(
                  (result) => {},
                  (error) => {
                    console.error(error);
                  }
                );
            },
            (error) => {
              console.error(error);
            }
          );
      },
      (error) => {
        console.error(error);
      }
    );

    this.nextPage();
  }

  nextPage() {
    this.page++;
  }

  previousPage() {
    this.page--;
  }

  openDSDialog() {
    const dialogRef = this.dialog.open(DatasecurityComponent, {
      centered: true,
      backdrop: true,
    });

    dialogRef.result.then(
      (result) => {
        //this.ngOnInit();
      },
      (backdrop) => {}
    );
  }

  checkPassword(p) {
    // This regex will enforce these rules:
    // At least one upper case English letter,  (?=.*?[A-Z])
    // At least one lower case English letter,  (?=.*?[a-z])
    // At least one digit,                      (?=.*?[0-9])
    // At least one special character,          (?=.*?[#?!@$%^&*-])
    // Minimum ten in length.                   {10,}

    // let requirements = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d){10,}$/

    this.passwordQuality = 0;

    let upperCase = /^(?=.*[A-Z])/g;
    this.passwordHasUpperCase = upperCase.test(p);
    if (
      upperCase.test(p) &&
      p.match(upperCase) &&
      p.length > this.passwordQuality * 2
    )
      this.passwordQuality += 1;

    let lowerCase = /^(?=.*[a-z])/g;
    this.passwordHasLowerCase = lowerCase.test(p);
    if (
      lowerCase.test(p) &&
      p.match(lowerCase) &&
      p.length > this.passwordQuality * 2
    )
      this.passwordQuality += 1;

    let digit = /^(?=.*\d)/g;
    this.passwordHasDigit = digit.test(p);
    if (digit.test(p) && p.match(digit) && p.length > this.passwordQuality * 2)
      this.passwordQuality += 1;

    this.passwordHasLength = p.length >= 10;
    this.passwordQuality += parseInt(Math.abs(p.length / 10).toFixed(0));

    let specialCharacter = /^(?=.*?[#?!@$%^&*-])/;
    this.passwordHasSpecialCharacter = specialCharacter.test(p);
    if (specialCharacter.test(p)) this.passwordQuality += 1;

    if (this.passwordQuality > this.passwordRatings.length - 1) {
      this.passwordRating = this.passwordRatings[this.passwordRatings.length];
    } else {
      this.passwordRating = this.passwordRatings[this.passwordQuality];
    }

    this.passwordIsMatching =
      this.formService.form.get("newPassword").value ==
      this.formService.form.get("newPasswordConfirm").value;
  }

  sendToLogin() {
    this.router.navigate(["/auth/login"]);
  }
}
